import React from 'react';
import styled from '@emotion/styled';
import { Widget } from '../../molecules/Widget';
import { Vehicle } from 'core/models/vehicle';
import { TitlePane } from 'components/views/atoms/TitlePane';

const Frame = styled.div({
    backgroundColor: '#E9EEF4',
});

const Title = styled(TitlePane)({
    marginBottom: '5px',
});

const List = styled.div({
    backgroundColor: '#fff',
});

const Item = styled.div({
    border: '1px solid #ddd',
    color: '#555',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'Raleway, sans-serif',
    padding: '10px 15px',
    margin: 0,
    borderBottom: 'none',
    ':hover': {
        backgroundColor: '#f5f5f5',
    },
    ':first-of-type': {
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
    },
    ':last-of-type': {
        borderBottomLeftRadius: '5px',
        borderBottomRightRadius: '5px',
        borderBottom: '1px solid #ddd',
    },
});

export type VehicleSelectorProps = {
    title: string;
    vehicles: Vehicle[];
    onSelect: (vehicle: Vehicle) => void;
}

export const VehicleSelector = (props: VehicleSelectorProps) => {
    return (
        <Frame>
            <Title title={props.title} />
            <Widget title='Select Vehicle'>
                <List>
                    {
                        props.vehicles.map(v =>
                            <Item key={v.id} onClick={() => props.onSelect(v)}>{v.name}</Item>
                        )
                    }
                </List>
            </Widget>
        </Frame>
    );
};
